import { z } from 'zod';

const ConfigJsonResponseBody = z.object({
  apiBaseUrl: z.string().url(),
});

export type ApiClientConfig = z.infer<typeof ConfigJsonResponseBody>;

const WordListResponseBody = z.object({
  list: z.array(z.string()),
});

const GetDekResponseBody = z.object({
  url: z.string().url(),
  encryptedDek: z.string(),
  contentType: z.string(),
  fileType: z.string(),
  fileName: z.string(),
  fileSize: z.number(),
});
export type GetDekResponseBody = z.infer<typeof GetDekResponseBody>;

export class ApiClient {
  constructor(
    private readonly config: ApiClientConfig,
    private readonly http: typeof fetch = fetch.bind(window) // Use the global fetch function
  ) {
  }

  get baseUrl(): string {
    return this.config.apiBaseUrl;
  }

  static async fromConfigJson(http: typeof fetch = fetch.bind(window)): Promise<ApiClient> {
    const response = await http('config.json');
    if (!response.ok) {
      throw new Error(`Failed to fetch config: ${response.statusText}`);
    }
    const body = await response.json();
    const config = ConfigJsonResponseBody.parse(body);
    return new ApiClient(config, http);
  }

  async getWordList(): Promise<string[]> {
    const response = await this.http('list.json');
    if (!response.ok) {
      throw new Error(`Failed to fetch word list: ${response.statusText}`);
    }
    const data = await response.json();
    const wordList = WordListResponseBody.parse(data);
    return wordList.list;
  }

  async getDek(
    secureContentsId: string,
  ): Promise<GetDekResponseBody> {
    const endpoint = `${this.baseUrl}/secure-contents/${secureContentsId}/dek`;
    const response = await this.http(endpoint, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`Failed to get DEK: ${response.statusText}`);
    }

    const data = await response.json();
    return GetDekResponseBody.parse(data);
  }
}
